"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Others = function Others(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M17.3034 6.69677C16.0764 5.46981 14.462 4.70623 12.7352 4.53613C11.0084 4.36604 9.27602 4.79996 7.83327 5.76396C6.39053 6.72795 5.32667 8.16238 4.82296 9.82283C4.31926 11.4833 4.40688 13.267 5.07089 14.8701C5.73491 16.4732 6.93423 17.7965 8.46451 18.6144C9.99479 19.4324 11.7613 19.6944 13.4632 19.3559C15.165 19.0174 16.6968 18.0993 17.7976 16.758C18.8984 15.4167 19.5 13.7352 19.5 12C19.5027 11.0147 19.3099 10.0387 18.9329 9.12836C18.5558 8.21806 18.002 7.39159 17.3034 6.69677ZM17.7252 15.0752L15.1618 15.5012L14.1258 14.0753L14.9397 11.5706L16.6159 11.0259L18.4405 12.8784C18.3362 13.6477 18.0939 14.3919 17.7252 15.0752ZM8.83822 15.5012L6.27481 15.0752C5.90613 14.3919 5.66384 13.6477 5.55959 12.8784L7.38411 11.0259L9.06034 11.5705L9.87422 14.0753L8.83822 15.5012ZM6.71322 10.2822L5.51972 11.4939C5.59873 10.4693 5.92123 9.47832 6.46039 8.60344L6.71322 10.2822ZM10.7387 13.5L9.95914 11.1008L12 9.61802L14.0409 11.1008L13.2613 13.5H10.7387ZM17.2869 10.2822L17.5397 8.60344C18.0789 9.47829 18.4015 10.4692 18.4806 11.4939L17.2869 10.2822ZM16.6935 7.5078L16.3069 10.075L14.9399 10.5192C14.9342 10.5145 14.9286 10.5098 14.9225 10.5053L12.5 8.74522V7.3091L14.825 6.14669C15.5238 6.48574 16.1565 6.94666 16.6935 7.5078ZM13.5215 5.68024L12 6.44099L10.4785 5.68027C11.4786 5.43992 12.5214 5.43992 13.5215 5.68027V5.68024ZM9.17514 6.14658L11.5 7.30905V8.74516L9.07747 10.5053C9.07145 10.5096 9.06583 10.5144 9.06006 10.5192L7.69314 10.075L7.3065 7.50794C7.84352 6.94669 8.4763 6.48569 9.17514 6.14658ZM7.05986 16.2194L8.73253 16.4972L9.51586 18.0061C8.56817 17.6118 7.72675 16.9997 7.05986 16.2194ZM10.8455 18.3972L9.64722 16.0889L10.8017 14.5H13.1983L14.3528 16.0889L13.1545 18.3972C12.3909 18.5342 11.6091 18.5342 10.8455 18.3972ZM14.4842 18.0061L15.2675 16.4972L16.9402 16.2194C16.2733 16.9997 15.4319 17.6119 14.4842 18.0062V18.0061Z",
    fill: props.foregroundColor,
    stroke: "#44403E",
    strokeWidth: "0.0138889"
  }));
};

Others.defaultProps = {
  altText: "Others",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
Others.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Others;
exports.default = _default;